import styled from "styled-components";
import { fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

export const ContentContainer = styled.div<{ isWineDetailsPage: boolean }>`
  padding: ${(props) => (props.isWineDetailsPage ? "40px 0 40px 80px" : "32px 15px")};
  min-height: 300px;

  ${breakpoints.smDown} {
    padding: ${(props) => props.isWineDetailsPage && "32px 15px"};
  }
`;

export const Header = styled.div<{ color: string }>`
  font-size: 35px;
  line-height: 32px;
  letter-spacing: 1.1px;
  color: ${(props) => props.color};
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  margin-bottom: 0px;
`;

export const WineCardContainer = styled.div`
  margin-top: 30px;
  flex-flow: row nowrap;
`;

export const WineCardWrapper = styled.div`
  margin-right: -4px;
  flex-shrink: 0;
`;

export const WineCardsWrapper = styled.div<{ length: number }>`
  display: flex;
  overflow: scroll;
  flex-flow: row nowrap;

  ::-webkit-scrollbar,
  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track {
    display: none;
  }
`;

export const ArrowWrapper = styled.div<{ isWineDetailsPage: boolean }>`
  margin-bottom: 20px;
  display: flex;
  justify-content: end;
  ${(props) => props.isWineDetailsPage && "margin-right: 24px"}

  ${breakpoints.mdDown} {
    display: none;
  }
`;
